import { Fragment, type ReactNode } from "react";
import { kawalkiZZaznaczeniem, type ZakresZaznaczenia } from "./fragmenty.js";

/**
 * Tekst jednego fragmentu dymka z zaznaczonymi trafieniami powtarzanego slowa (<mark class="trafienie-slowa">), wspolny
 * dla transkryptu aplikacji i linku recenzenta. Zaznaczenie lezy WEWNATRZ fragmentu, wiec cytat ze wskazania (zloty
 * marker albo szare podkreslenie) zostaje nietkniety, a trafienie dostaje tylko neutralny obrys (session.css).
 *
 * Bez zaznaczen zwraca sam tekst: DOM dymka jest wtedy dokladnie taki jak bez tej funkcji.
 */
export function tekstZZaznaczeniem(tekst: string, od: number, zaznaczenia: readonly ZakresZaznaczenia[]): ReactNode {
  if (zaznaczenia.length === 0) return tekst;
  const kawalki = kawalkiZZaznaczeniem(tekst, od, zaznaczenia);
  if (!kawalki.some((k) => k.zaznaczony)) return tekst;
  return kawalki.map((k, i) =>
    k.zaznaczony ? (
      <mark className="trafienie-slowa" key={i}>
        {k.tekst}
      </mark>
    ) : (
      <Fragment key={i}>{k.tekst}</Fragment>
    ),
  );
}
